export default __webpack_public_path__ + "static/workflow_bg-71a2c7be077ddab879c4958682e0ba35.webp";